function Contact(){
    return(
        <main className="main-content">
            <p>página de contacto</p>
        </main>
    )
}

export default Contact;
